(function () {
  function apply(views) {
    document.querySelectorAll('[data-article-handle]').forEach(function (el) {
      // article.handle in Liquid is blog-prefixed ("news/my-post"); GA4 keys are bare.
      var handle = el.getAttribute('data-article-handle').split('/').pop();
      var count = views[handle];
      if (!count) return;
      var span = el.querySelector('.blog-posts__views-count');
      if (span) span.textContent = count.toLocaleString() + ' views';
      el.style.display = '';
    });
  }

  function load() {
    fetch('https://bot.hanayastore.com/public/blog-views', { cache: 'no-store' })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (data) { if (data && data.views) apply(data.views); })
      .catch(function () {});
  }

  if ('requestIdleCallback' in window) {
    requestIdleCallback(load, { timeout: 3000 });
  } else {
    window.addEventListener('load', load);
  }
})();
